import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const SERVICES = [
  {
    key: "fert",
    icon: "fa-box",
    tag: "QR Bag Tracking",
    title: "Fertilizer Bag Tracking",
    desc: "Track every urea bag from factory to farmer — QR verification, OTP + Aadhaar identity, GPS location and AI fraud detection.",
    features: ["QR Scan — no app", "Fraud Detection", "Live Dashboard", "Subsidy Ready"],
    to: "/login",
  },
  {
    key: "fleet",
    icon: "fa-truck-fast",
    tag: "Live GPS Tracking",
    title: "Fleet GPS Tracking",
    desc: "Real-time truck tracking on live maps — trips, routes & ETA, overspeed and route-deviation alerts, plus analytics reports.",
    features: ["Live GPS Map", "Trip Management", "Route Alerts", "Analytics & Reports"],
    to: "/fleet/login",
  },
];

export default function Services() {
  return (
    <section className="section services" id="services" data-testid="services-section">
      <div className="section-inner">
        <div className="why-header">
          <Reveal>
            <span className="section-eyebrow">Two Platforms · One System</span>
            <h2 className="section-heading">
              Choose your <em>service</em>
            </h2>
            <p className="section-desc">
              Fertilizer bag traceability and live fleet GPS tracking — powered by the same
              secure, government-grade platform.
            </p>
          </Reveal>
        </div>

        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <Reveal key={s.key} delay={i * 140}>
              <div className={`service-card service-${s.key}`} data-testid={`service-card-${s.key}`}>
                <span className="service-glow" />
                <div className="service-icon">
                  <i className={`fa-solid ${s.icon}`}></i>
                </div>
                <span className="service-tag">{s.tag}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <ul className="service-feats">
                  {s.features.map((f) => (
                    <li key={f}>
                      <i className="fa-solid fa-check"></i>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link to={s.to} className="service-cta">
                  Open Portal <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
